var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"size":"16","color":"black"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('pasteContent')}}},on),[_vm._v(" mdi-content-paste ")])]}}])},[_c('span',[_vm._v("Paste content")])])}
var staticRenderFns = []

export { render, staticRenderFns }